module.exports = __webpack_public_path__ + "img/no-manager-th.5173c42.png";